import { Loading } from '@perch-labs/shrike';
import React, { useEffect, useMemo, useState } from 'react';
import { BottomDrawer } from '~/components/drawer/drawer.component';
import { config as communitySolarConfig } from '~/funnels/community-solar/config';
import { FetchUtilityResponse } from '~/services/fetch-utility';
import { FunnelTrack } from '~/typings/graphql';
import { SPONSORED_SOLAR_STATES, SPONSORED_SOLAR_STATES_NAME } from '~/utils/constants';
import { hardRedirect } from '~/utils/for-warbler';
import { RedirectParams, createFunnelPath } from '~/utils/redirects';
import { store } from '~/utils/store';
import { SignupComponent } from './signup.component';

export const SignupWrapper: React.FC<{}> = () => {
  const [error, setError] = useState<Error | null>(null);
  const [showDrawer, setShowDrawer] = useState<boolean>(false);
  const [redirectPath, setRedirectPath] = useState<string | null>(null);

  const { utility, zipCode } = useMemo(() => {
    try {
      const utility = store.get('UTILITY_SELECTION') as FetchUtilityResponse;
      const zipCode = store.get('ZIP_CODE')!;
      return { utility, zipCode };
    } catch (error) {
      setError(new Error('Something went wrong. Please try again.'));
      return { utility: null, zipCode: null };
    }
  }, []);

  useEffect(() => {
    if (utility && zipCode) {
      const redirectParams: RedirectParams = { utility, zipCode, queryParams: {} };
      setShowDrawer(shouldShowDrawer(utility));
      setRedirectPath(createFunnelPath(communitySolarConfig.path, redirectParams));
    }
  }, [utility, zipCode]);

  if (!utility || !zipCode) {
    return <Loading />;
  }

  return showDrawer ? (
    <>
      <BottomDrawer
        open={showDrawer}
        onClick={redirectPath ? () => hardRedirect(redirectPath) : undefined}
        context={{
          inputState: utility.state.name,
          availableState: SPONSORED_SOLAR_STATES_NAME.toString(),
          funnelTrack: utility.funnelTrack,
        }}
      />
      <Loading />
    </>
  ) : (
    <SignupComponent error={error} />
  );
};

export const shouldShowDrawer = (utility: FetchUtilityResponse): boolean => {
  return !(
    SPONSORED_SOLAR_STATES.includes(utility.state.abbreviation) &&
    utility.funnelTrack !== ('waitlist' as FunnelTrack)
  );
};
